var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.29988C11 5.85812 10.5523 5.5 10 5.5C9.44772 5.5 9 5.85812 9 6.29988V14.7001C9 15.1419 9.44772 15.5 10 15.5C10.5523 15.5 11 15.1419 11 14.7001V6.29988Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79988 9.5C5.35812 9.5 5 9.94772 5 10.5C5 11.0523 5.35812 11.5 5.79988 11.5H14.2001C14.6419 11.5 15 11.0523 15 10.5C15 9.94772 14.6419 9.5 14.2001 9.5H5.79988Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.97da958c5b76fc4265bff3e0a2062bea.svg";
export { ForwardRef as ReactComponent };